import { render, staticRenderFns } from "./AboutNormaCS.vue?vue&type=template&id=74b21d3c&"
import script from "./AboutNormaCS.vue?vue&type=script&lang=js&"
export * from "./AboutNormaCS.vue?vue&type=script&lang=js&"
import style0 from "./about.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports